export type IFormLeadStatus = 'Sem Contato' | 'Qualificado' | 'Desqualificado'

export interface IFormLead {
  id: number
  name: string
  email: string
  phone: string
  format: string
  area: string
  course: string
  source: string
  seller_name: string
  status: IFormLeadStatus
  utm_campaign: string
  utm_source: string
  utm_medium: string
  utm_content: string
  utm_term: string
  created_at: string
}

export const statusTranslations: Record<IFormLeadStatus, string> = {
  'Sem Contato': 'Sem Contato',
  Qualificado: 'Qualificado',
  Desqualificado: 'Desqualificado'
}

export const statusColors: Record<IFormLeadStatus, string> = {
  'Sem Contato': 'yellow',
  Qualificado: 'green',
  Desqualificado: 'red'
}
